// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"047b78e6","162":"12410307","294":"37e96369","394":"a0acf053","562":"cf1cff76"}[chunkId] + ".chunk.js";
};